import { useState } from "react";
import axios from "axios";
import { Send, Check, Loader2 } from "lucide-react";
import { useSite } from "@/lib/site";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : null;
const field = "w-full rounded-2xl border border-[var(--line)] bg-[var(--bg2)] px-4 py-3.5 text-sm text-[var(--text)] placeholder:text-[var(--faint)] outline-none transition-colors focus:border-[#8B5CF6]";

export const ContactForm = () => {
  const { t } = useSite();
  const f = t.contact.form;
  const [data, setData] = useState({ name: "", email: "", message: "", website: "" });
  const [state, setState] = useState("idle");
  const set = (k) => (e) => setData((d) => ({ ...d, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!API) { setState("error"); return; }
    setState("sending");
    try {
      await axios.post(`${API}/contact`, data);
      setState("sent");
      setData({ name: "", email: "", message: "", website: "" });
    } catch {
      setState("error");
    }
  };

  return (
    <form onSubmit={submit} className="rb-card flex h-full flex-col gap-4 rounded-3xl p-7 sm:p-9" data-testid="contact-form">
      <p className="font-mono text-xs uppercase tracking-widest text-[var(--muted)]">{f.title}</p>
      <div className="grid gap-4 sm:grid-cols-2">
        <input required minLength={2} maxLength={100} value={data.name} onChange={set("name")} placeholder={f.name} className={field} data-testid="contact-name-input" />
        <input required type="email" value={data.email} onChange={set("email")} placeholder={f.email} className={field} data-testid="contact-email-input" />
      </div>
      <textarea required minLength={10} maxLength={3000} rows={5} value={data.message} onChange={set("message")} placeholder={f.message} className={`${field} resize-none`} data-testid="contact-message-input" />
      <input tabIndex={-1} autoComplete="off" value={data.website} onChange={set("website")} className="hidden" aria-hidden="true" />
      <div className="flex flex-wrap items-center gap-4">
        <button type="submit" disabled={state === "sending"} className="pill-primary inline-flex items-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold disabled:opacity-60" data-testid="contact-submit-btn">
          {state === "sending" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} {state === "sending" ? f.sending : f.submit}
        </button>
        {state === "sent" && <p className="flex items-center gap-1.5 text-sm text-[#22C55E]" data-testid="contact-success"><Check className="h-4 w-4" /> {f.sent}</p>}
        {state === "error" && <p className="text-sm text-[#EF4444]" data-testid="contact-error">{f.error}</p>}
      </div>
    </form>
  );
};
